import React, { useState, useEffect } from "react";
import { Formik, Field } from "formik";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MainSidebar from "../Mainsidebar";
import UserNavbar from "../UserNavbar";
import UserFooter from "../UserFooter";
import "../../Style/NewLead.css";
import { path_url } from "../../Config/config";
import SpeechToText from "../../AI/SpeechToText";
import { useNavigate } from "react-router-dom";

import CsvImport_lead from "./CsvImport_lead";
import { Modal } from "@mui/material";
import { useParams } from "react-router-dom";
import { useCurrentUser } from "../../context/UserContext";
import { isUUID } from "../../Utils/auth";

function NewLead() {
  const { currentUser } = useCurrentUser();
  const { id } = useParams();
  const [initialData, setInitialData] = useState(null);

  useEffect(() => {
    if (id) {
      const fetchData = async () => {
        try {
          const res = await axios.get(`${path_url}/lead/details/${id}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
          });
          setInitialData(res.data.body.lead || res.data.body);
        } catch (err) {
          console.error(err);
        }
      };
      fetchData();
    }
  }, [id]);
  const [showModal, setShowModal] = useState(false);
  const [hamburger, sethamburger] = useState(false);
  const [isRightMenu, setisRightMenu] = useState(false);
  const [isSearchShow, setIsSearchShow] = useState(false);
  const [fullScreen, setFullScreen] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(true);
  const handleScreenEnter = () => {
    setFullScreen(false);
    document.body.requestFullscreen();
  };
  const handleScreenExit = () => {
    setFullScreen(true);
    document.exitFullscreen();
  };
  const handelShow = () => setIsSearchShow(!isSearchShow);
  const handelRightMenuShow = () => setisRightMenu(!isRightMenu);
  const handleclickonbutton = (hamburger) => {
    if (document.documentElement.clientWidth <= 800)
      return { width: "100%", left: "0rem" };
    else
      return {
        width: !hamburger && "-webkit-fill-available",
        left: !hamburger && "3.7rem",
      };
  };
  const handleclickonbutton1 = (hamburger) => {
    if (document.documentElement.clientWidth <= 800) {
      return { display: hamburger && "none" };
    }
  };
  const options = [
    { value: "Phone", label: "Phone" },
    { value: "Email", label: "Email" },
  ];

  const Enum = [
    { value: "OPEN", label: "Open" },
    { value: "ATTEMPTEDCONTACT", label: "Attempted Contact" },
    { value: "NOTENGAGED", label: "Not Engaged" },
    { value: "NEEDSFOLLOWUP", label: "Needs Follow Up" },
    { value: "WORKING", label: "Working" },
    { value: "NEWOPPORTUNITY", label: "New Opportunity" },
    { value: "QUALIFIED", label: "Qualified" },
    { value: "DISQUALIFIED", label: "Disqualified" },
    { value: "CONVERTTOCUSTOMER", label: "Convert To Customer" },
  ];
  const handleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const navigate = useNavigate();

  return (
    <>
      <div className="con1 d-flex">
        <div className="subcon1" style={handleclickonbutton1(hamburger)}>
          <MainSidebar hamburger={hamburger} sethamburger={sethamburger} />
        </div>
        <div className="subcon2" style={handleclickonbutton(hamburger)}>
          <UserNavbar
            hamburger={hamburger}
            sethamburger={sethamburger}
            handelRightMenuShow={handelRightMenuShow}
            handelShow={handelShow}
            isSearchShow={isSearchShow}
            handleScreenEnter={handleScreenEnter}
            handleScreenExit={handleScreenExit}
            fullScreen={fullScreen}
          />
          <div className="mt-2">
            <Formik
              enableReinitialize={true}
              initialValues={{
                // "readstatus":"...",
                // "product":"...",
                // "owner":"..."

                firstname: initialData?.firstname || "",
                lastname: initialData?.lastname || "",
                companyname: initialData?.companyname || "",
                mobile: initialData?.mobile || "",
                altphone: initialData?.altphone || "",
                email: initialData?.email || "",
                department: initialData?.department || "",
                designation: initialData?.designation || "",
                category: initialData?.category || "",
                reportTo: initialData?.reportTo || "",
                gstnumber: initialData?.gstnumber || "",
                website: initialData?.website || "",
                address1: initialData?.add1 || initialData?.address1 || "",
                address2: initialData?.add2 || initialData?.address2 || "",
                address3: initialData?.address3 || "",
                city: initialData?.city || "",
                pincode: initialData?.pincode || "",
                state: initialData?.state || "",
                country: initialData?.country || "",
                notes: initialData?.notes || "",
                bestwaycontact: initialData?.bestwaycontact || "Mobile",
                leadsource: initialData?.leadsource || "Indiamart",
                status: initialData?.status || "OPEN",
                usercid: initialData?.usercid || currentUser?.id || localStorage.getItem("userId") || localStorage.getItem("adminId"),
                useradminid: initialData?.useradminid || currentUser?.useradminid || currentUser?.id || localStorage.getItem("adminId"),
                owner: initialData?.owner || currentUser?.useradminid || currentUser?.id || localStorage.getItem("adminId"),
              }}
              onSubmit={async (values) => {
                try {
                  const nameRegex = /^[a-zA-Z\s]{2,}$/;
                  const phoneNumberRegex = /^\d{10,15}$/;
                  const pincodeRegex = /^\d{6}$/;
                  const stateCountryRegex = /^[a-zA-Z\s]+$/;
                  const emailRegex =
                    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                  const addressRegex = /^[a-zA-Z0-9\s,.-]+$/;

                  const errors = [];
                  const req = [];
                  if (!values.firstname) {
                    req.push("Name");
                  }
                  if (!values.mobile) {
                    req.push("Phone number");
                  }
                  if (!values.email) {
                    req.push("Email address");
                  }

                  // Validate mandatory fields
                  if (
                    (values.firstname && !nameRegex.test(values.firstname)) ||
                    (values.lastname && !nameRegex.test(values.lastname))
                  ) {
                    errors.push("Name");
                  }
                  if (values.mobile && !phoneNumberRegex.test(values.mobile)) {
                    errors.push("Phone number");
                  }
                  if (values.email && !emailRegex.test(values.email)) {
                    errors.push("Email address");
                  }

                  if (values.pincode && !pincodeRegex.test(values.pincode)) {
                    errors.push("Pincode");
                  }
                  if (values.state && !stateCountryRegex.test(values.state)) {
                    errors.push("State name");
                  }
                  if (
                    values.country &&
                    !stateCountryRegex.test(values.country)
                  ) {
                    errors.push("Country name");
                  }
                  if (values.address1 && !addressRegex.test(values.address1)) {
                    errors.push("Address format");
                  }
                  if (!values.status) {
                    values.status = "OPEN";
                  }

                  if (req.length > 0) {
                    const reqMessage = req.join(", ") + " is required";
                    toast.error(reqMessage);
                  } else if (errors.length > 0) {
                    const errorMessage = "Invalid " + errors.join(", ");
                    toast.error(errorMessage);
                  } else {
                    const token = localStorage.getItem("accessToken");
                    let response;
                    const validUserCid = [values.usercid, currentUser?.id, localStorage.getItem("userId"), localStorage.getItem("adminId")].find(val => isUUID(val)) || null;
                    const validAdminId = [values.useradminid, currentUser?.useradminid, currentUser?.id, localStorage.getItem("adminId"), validUserCid].find(val => isUUID(val)) || null;

                    if (!validUserCid) {
                      toast.error("Invalid usercid session. Please log in again.");
                      return;
                    }

                    const submitPayload = {
                      ...(id ? { ...values, id } : values),
                      usercid: validUserCid,
                      useradminid: validAdminId,
                      owner: validUserCid || validAdminId,
                    };

                    response = await axios.post(
                      `${path_url}/lead`,
                      submitPayload,
                      {
                        headers: {
                          Authorization: `Bearer ${token}`,
                          "Content-Type": "application/json",
                        },
                      },
                    );
                    if (
                      response &&
                      (response.data.statusCodeValue === 200 ||
                        response.status === 200 ||
                        response.status === 201)
                    ) {
                      toast.success(
                        id
                          ? "Lead updated successfully"
                          : "Form submitted successfully",
                      );
                      setTimeout(() => {
                        navigate(-1);
                      }, 1000);
                    } else if (response) {
                      toast.error(
                        response.data?.body || "Failed to submit form",
                      );
                    }
                  }
                } catch (error) {
                  console.error("Submit error:", error);
                  toast.error(
                    "An error occurred: " +
                      (error.response?.data?.message ||
                        error.response?.data?.body ||
                        error.message),
                  );
                }
              }}
            >
              {(formik) => (
                <form action="" onSubmit={formik.handleSubmit}>
                  <fieldset style={{ marginBottom: "5rem" }}>
                    <div className="col-12 d-flex justify-content-center">
                      <div className="bg-white col-11 cont">
                        <div className="d-flex justify-content-center">
                          <div
                            style={{ boxShadow: "0 1px 1px lightgray" }}
                            className=" col-12 m-1 mt-2 mb-3  elevation-2 d-flex justify-content-between align-items-center p-2"
                          >
                            <p
                              style={{ color: "gray" }}
                              className=" p-1 m-0 custom-font-size"
                            >
                              <strong>New Lead</strong>
                            </p>
                            <div className="d-flex input-with-speech">
                              <input
                                id="voice-input-box"
                                type="text"
                                placeholder="Voice input displayed here..."
                                disabled
                              ></input>
                              <SpeechToText
                                inputId="voice-input-box"
                                style={{ marginBottom: "10px" }}
                              />

                              <img
                                onClick={() => setShowModal(true)}
                                src="/assets/import.png"
                                alt="import"
                                style={{
                                  height: "25px",
                                  width: "25px",
                                  marginLeft: "10px",
                                  cursor: "pointer",
                                }}
                              />
                            </div>

                            {showModal && (
                              <Modal
                                open={showModal}
                                onClose={() => setShowModal(false)}
                                aria-labelledby="csv-import-modal"
                                aria-describedby="csv-import-description"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <div
                                  style={{
                                    backgroundColor: "white",
                                    padding: "20px",
                                    borderRadius: "8px",
                                    width: "400px",
                                    textAlign: "center",
                                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                  }}
                                >
                                  <CsvImport_lead
                                    closeModal={() => setShowModal(false)}
                                  />
                                  <button
                                    onClick={() => setShowModal(false)}
                                    style={{
                                      marginTop: "10px",
                                      backgroundColor: "gray",
                                      color: "white",
                                      border: "none",
                                      padding: "10px",
                                      borderRadius: "5px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    Close
                                  </button>
                                </div>
                              </Modal>
                            )}
                          </div>
                        </div>
                        {/* <div className="border col-11 mt-1 ml-5 "></div> */}

                        <div className="d-flex flex-wrap">
                          <div className="col-12 col-md-6 pl-0 pr-0 ">
                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Company Name</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8  forms">
                                <input
                                  type="text"
                                  placeholder="Company Name"
                                  name="companyname"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.companyname}
                                />
                                {formik.touched.companyname &&
                                  formik.errors.companyname && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.companyname}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Name</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 d-flex p-0 justify-content-end">
                                <div className="col-sm-6 pb-1  forms">
                                  <input
                                    type="text"
                                    placeholder="First Name"
                                    name="firstname"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.firstname}
                                  />
                                  {formik.touched.firstname &&
                                    formik.errors.firstname && (
                                      <span style={{ color: "red" }}>
                                        {formik.errors.firstname}
                                      </span>
                                    )}
                                </div>

                                <div className="col-sm-6 justify-content-end  forms">
                                  <input
                                    type="text"
                                    placeholder="Last Name"
                                    name="lastname"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.lastname}
                                  />
                                </div>
                                <div className="p-0 m-0 d-flex justify-content-center">
                                  {formik.touched.lastname &&
                                    formik.errors.lastname && (
                                      <span style={{ color: "red" }}>
                                        {formik.errors.lastname}
                                      </span>
                                    )}
                                </div>
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex  mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Status</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8">
                                <select
                                  className="selectBox custom-select "
                                  name="status"
                                  id="status"
                                  value={formik.values.status}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                >
                                  {Enum.map((option) => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-12 col-sm-12 d-flex  mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Source</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8">
                                <select
                                  name="leadsource"
                                  id="leadsource"
                                  className="selectBox custom-select "
                                  value={formik.values.leadsource}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                >
                                  <option value="Indiamart">Indiamart</option>
                                  <option value="Website">Website</option>
                                  <option value="Referral">Referral</option>
                                  <option value="Social Media">Social Media</option>
                                  <option value="Cold Call">Cold Call</option>
                                  <option value="Other">Other</option>
                                </select>
                              </div>
                            </div>
                            {/* <div className="border col-12 ml-1 mb-3"></div> */}
                          </div>

                          <div className="col-12 col-md-6 pl-0 pr-0">
                            <div className="col-12 col-sm-12 d-flex  mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left "
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Best Way to Contact</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8">
                                <select
                                  name="bestwaycontact"
                                  id="bestwaycontact"
                                  className="selectBox custom-select "
                                  value={formik.values.bestwaycontact}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                >
                                  <option value="Mobile">Mobile</option>
                                  {options.map((option) => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex  mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Mobile</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8  forms">
                                <input
                                  type="number"
                                  placeholder="Mobile"
                                  name="mobile"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.mobile}
                                />
                                {formik.touched.mobile &&
                                  formik.errors.mobile && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.mobile}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex  mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Phone</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8  forms">
                                <input
                                  type="number"
                                  placeholder="Phone"
                                  name="altphone"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.altphone}
                                />
                                {formik.touched.altphone &&
                                  formik.errors.altphone && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.altphone}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex  mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Email</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8  forms">
                                <input
                                  type="text"
                                  placeholder="Email"
                                  name="email"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.email}
                                />
                                {formik.touched.email &&
                                  formik.errors.email && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.email}
                                    </span>
                                  )}
                              </div>
                            </div>

                            {/* <div className="border col-12 ml-1 mb-3"></div> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 d-flex justify-content-center">
                      <div className="bg-white col-11 mt-3 cont">
                        <div className="d-flex justify-content-center">
                          <div
                            style={{ boxShadow: "0 1px 1px lightgray" }}
                            className=" col-12 m-1 mt-2 mb-3  elevation-2"
                          >
                            <p
                              style={{ color: "gray" }}
                              className=" p-1 m-0 custom-font-size"
                            >
                              <strong>Other Informations</strong>
                            </p>
                          </div>
                        </div>
                        {/* <div className="border rounded border-gray col-11 mt-1 ml-5 "></div> */}

                        <div className="d-flex flex-wrap ">
                          <div className="col-12 col-md-6 pl-0 pr-0 ">
                            <div className="col-12 col-sm-12 d-flex  mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Department</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8  forms">
                                <input
                                  type="text"
                                  placeholder="Department"
                                  name="department"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.department}
                                />
                                {formik.touched.department &&
                                  formik.errors.department && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.department}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex  mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Designation</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8  forms">
                                <input
                                  type="text"
                                  placeholder="Designation"
                                  name="designation"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.designation}
                                />
                                {formik.touched.designation &&
                                  formik.errors.designation && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.designation}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex  mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Category</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8  forms">
                                <input
                                  type="text"
                                  placeholder="Category"
                                  name="category"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.category}
                                />
                                {formik.touched.category &&
                                  formik.errors.category && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.category}
                                    </span>
                                  )}
                              </div>
                            </div>

                            {/* <div className="border col-12 ml-1 mb-3"></div> */}
                          </div>

                          <div className="col-12 col-md-6 pl-0 pr-0">
                            <div className="col-12 col-sm-12 d-flex  mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>ReportTo</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="ReportTo"
                                  name="reportTo"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.reportTo}
                                />
                                {formik.touched.reportTo &&
                                  formik.errors.reportTo && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.reportTo}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex  mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>GSTIN</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="GST Number"
                                  name="gstnumber"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.gstnumber}
                                />
                                {formik.touched.gstnumber &&
                                  formik.errors.gstnumber && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.gstnumber}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex  mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Website</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="https://abc.com/"
                                  name="website"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.website}
                                />
                                {formik.touched.website &&
                                  formik.errors.website && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.website}
                                    </span>
                                  )}
                              </div>
                            </div>

                            {/* <div className="border col-12 ml-1 mb-3"></div> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 d-flex justify-content-center">
                      <div className="bg-white col-11 mt-3 cont">
                        <div className="d-flex justify-content-center">
                          <div
                            style={{ boxShadow: "0 1px 1px lightgray" }}
                            className=" col-12 m-1 mt-2 mb-3  elevation-2"
                          >
                            <p
                              style={{ color: "gray" }}
                              className=" p-1 m-0 custom-font-size"
                            >
                              <strong>Address</strong>
                            </p>
                          </div>
                        </div>
                        {/* <div className="border rounded border-gray col-11 mt-1 ml-5 "></div> */}

                        <div className="d-flex flex-wrap ">
                          <div className="col-12 col-md-6 pl-0 pr-0 ">
                            <div className="col-12 col-sm-12 d-flex  mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Address1</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms ">
                                <input
                                  type="text"
                                  placeholder="Address1"
                                  name="address1"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.address1}
                                />
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex  mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Address2</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="Address2"
                                  name="address2"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.address2}
                                />
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex  mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Address3</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="Address3"
                                  name="address3"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.address3}
                                />
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex  mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>City</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="City"
                                  name="city"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.city}
                                />
                                {formik.touched.city && formik.errors.city && (
                                  <span style={{ color: "red" }}>
                                    {formik.errors.city}
                                  </span>
                                )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex  mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Pincode</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="number"
                                  placeholder="Pincode"
                                  name="pincode"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.pincode}
                                />
                                {formik.touched.pincode &&
                                  formik.errors.pincode && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.pincode}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex  mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>State</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="State"
                                  name="state"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.state}
                                />
                                {formik.touched.state &&
                                  formik.errors.state && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.state}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex  mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Country</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="Country"
                                  name="country"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.country}
                                />
                                {formik.touched.country &&
                                  formik.errors.country && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.country}
                                    </span>
                                  )}
                              </div>
                            </div>

                            {/* <div className="border col-12 ml-1 mb-3"></div> */}
                          </div>

                          <div className="col-12 col-md-6 pl-0 pr-0">
                            <div className="col-12 col-sm-12 d-flex  mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Notes</strong>
                                </label>
                              </div>

                              <div className="col-12 col-sm-8 forms">
                                <textarea
                                  type="text"
                                  id="notes"
                                  name="notes"
                                  rows={5}
                                  placeholder="Notes"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.notes}
                                />
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex  mb-2">
                              <div className="col-12 col-sm-6 d-flex justify-content-center p-2">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-light border rounded border-gray"
                                  onClick={() => navigate(-1)}
                                >
                                  Cancel
                                </button>
                              </div>
                              <div className="col-12 col-sm-6 d-flex justify-content-center p-2">
                                <button
                                  type="submit"
                                  className="btn btn-sm border rounded border-gray btn-info "
                                  style={{ backgroundColor: "" }}
                                >
                                  Save
                                </button>
                              </div>
                            </div>

                            {/* <div className="border col-12 ml-1 mb-3"></div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </form>
              )}
            </Formik>
          </div>
          <UserFooter />
          <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
        </div>
      </div>
    </>
  );
}

export default NewLead;
